import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost,
} from "./_wsApiFetchData";

export async function getOverview(language, timeZone) {
  try {
    const data = await wsRequestGet(
      "/admin/SignupsOverview/overview",
      language,
      timeZone
    );
    return {
      success: true,
      data
    };
  } catch (e) {
    console.error(`unable to get the overview: ${e}`);
    return {
      success: false,
    };
  }
}

export async function mute(signupId, isSignup, language, timeZone) {
  try {
    await wsRequestGet(
      "/admin/SignupsOverview/mute",
      language,
      timeZone,
      { signupId, isBooking: isSignup }
    );
    return {
      success: true,
    };
  } catch (e) {
    console.error(`unable to mute the signup: ${e}`);
    return {
      success: false,
    };
  }
}

// `force` retries even while the last attempt is still Pending (a stuck attempt).
// The backend refuses a retry with 409 and a reason (still Pending, cancelled
// signup, signup still booked); the reason is returned as `message`, and
// `canForce` says whether retrying with force=true would get past it.
export async function retry(signupId, isBooking, force, language, timeZone) {
  const request = {
    SignupId: signupId,
    IsBooking: isBooking
  }
  if (force) {
    request.Force = true;
  }
  try {
    await wsRequestGet(
      "/admin/SignupsOverview/add-signup-to-queue",
      language,
      timeZone,
      request
    );
    return {
      success: true,
    };
  } catch (e) {
    console.error(`unable to add signup to the queue: ${e}`);
    const message = e?.payload?.translatedMessage || undefined;
    return {
      success: false,
      message,
      canForce: !force && e?.payload?.statusCode === 409 && /still Pending/i.test(message || ''),
    };
  }
}

export async function editComment(signupId, comment, language, timeZone, cancelToken) {
  const request = {
    SignupId: signupId,
    Comment: comment
  }

  try {
    await wsRequestPost(`/admin/SignupsOverview/edit-comment`, language, timeZone, request, null, cancelToken);
    return {
      success: true
    }
  } catch (error) {
    return {
      success: false
    };
  }
}

export async function sendConfirmation(signupId, isSignup, language, timeZone) {
  try {
    return await wsRequestGet(
      "/admin/SignupsOverview/send-confirmation",
      language,
      timeZone,
      { signupId, forceIsBooking: isSignup }
    );
    
  } catch (e) {
    console.error(`unable to get user: ${e}`);
    return {
      success: false,
    };
  }
}